// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';
import { useCartContext } from 'modules/cart/contexts/CartContext';

import Checkbox from '../Checkbox';
import { cloneMetaData } from '../../modules/cart/utils';

const MAX_SELECTED_ASSOCIATE_PINS_COUNT = 2;

const AssociatePinsSelectors = ({ classes, pimSkuId }) => {
  const { productsMetaData, setProductsMetaData } = useCartContext();
  const associatePins = productsMetaData?.get(pimSkuId)?.associatePins ?? [];
  const totalSelectedPins = associatePins.reduce((acc, item) => Number(item.value) + acc, 0);
  const shouldBeDisabled = associatePins && totalSelectedPins >= MAX_SELECTED_ASSOCIATE_PINS_COUNT;

  const onPinChange = (pimSkuId, pin, newValue) => {
    const newMetaData = cloneMetaData(productsMetaData);
    const currentItemMeta = productsMetaData.get(pimSkuId);
    const associatePins = [...(currentItemMeta?.associatePins ?? [])];
    const pinIndex = associatePins.findIndex((item) => item.pin === pin);
    associatePins[pinIndex].value = newValue;

    newMetaData.set(pimSkuId, { ...currentItemMeta, associatePins });
    setProductsMetaData(newMetaData);
  };

  return (
    <Box data-testid="associate-pins-box" display="flex" alignItems="center">
      {associatePins &&
        associatePins.map(({ pin, value }) => (
          <Box key={pin} display="flex" alignItems="center" className={classes.checkboxContainer}>
            <Checkbox
              classes={{ labelRoot: classes.checkbox, disabled: classes.checkboxDisabled }}
              onChange={(e) => {
                onPinChange(pimSkuId, pin, e.target.checked);
              }}
              disabled={totalSelectedPins === 1 && value ? !shouldBeDisabled : !value && shouldBeDisabled}
              checked={value}
              data-testid={`pin-${pin}`}
            />
            <Typography className={classes.reminderBody}>{pin}</Typography>
          </Box>
        ))}
    </Box>
  );
};

AssociatePinsSelectors.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  pimSkuId: PropTypes.string,
};

AssociatePinsSelectors.defaultProps = {
  classes: {},
  pimSkuId: '',
};

export default AssociatePinsSelectors;
